import * as wActs from './website-actions.js';
import * as wConst from '../consts/website-consts';
import { fetch, addTask } from "domain-task";
import * as pConsts from "../consts/profiles-consts";


export function DoSearch(term) {
  return (dispatch, getState) => {
    dispatch({type: wConst.FETCH_SEARCH_PENDING, payload: false});
    const state = getState();
    let ref = "";
    if (typeof window !== "undefined") {
      ref = wActs.GetReferer();
    } else {
      ref = state.Website.ServerParams.Referer + state.Website.ServerParams.Query;
    }


    let page = wActs.getParameterByName("page", ref, null);
    if(page === null) { page = "1"; }
    if(isNaN(parseInt(page))) { page = "1"; }
    let qry = "?term=" + encodeURIComponent(term) + "&page=" + page;
    let srch = fetch(`${wConst.ROOT_URL(state.Website.Settings.ApiUrl)}/search${qry}`, { headers: { 'X-Alt-Referer': ref } })
      .then(resp => resp.json())
      .then(function (data) {
        if(data.Code === 200) {
          dispatch({type: wConst.FETCH_SEARCH_FULLFILLED, payload: data});
        } else {
          dispatch({type: wConst.FETCH_SEARCH_REJECTED, payload: data});
        }
      })
      .catch(function (ex, ex1) {
        dispatch({type: wConst.FETCH_SEARCH_REJECTED, payload: {Code: 500, Message: ex1.toString(), Result: {}}});
      });
    addTask(srch);
    return srch;
  }
}

export function DoGroups() {
  return (dispatch, getState) => {
    dispatch({type: wConst.FETCH_SEARCHGROUPS_PENDING, payload: false});
    const state = getState();
    let ref = "";
    if (typeof window !== "undefined") {
      ref = wActs.GetReferer();
    } else {
      ref = state.Website.ServerParams.Referer;
    }
    let srch = fetch(`${wConst.ROOT_URL(state.Website.Settings.ApiUrl)}/search/groups`, { headers: { 'X-Alt-Referer': ref } })
      .then(resp => resp.json())
      .then(function (data) {
        if(data.Code === 200) {
          dispatch({type: wConst.FETCH_SEARCHGROUPS_FULLFILLED, payload: data});
        } else {
          dispatch({type: wConst.FETCH_SEARCHGROUPS_REJECTED, payload: data});
        }
      })
      .catch(function (ex, ex1) {
        dispatch({type: wConst.FETCH_SEARCHGROUPS_REJECTED, payload: {Code: 500, Message: ex1.toString(), Result: []}});
      });
    addTask(srch);
    return srch;
  }
}
